import { CompaniesResponse, CompanyServiceResponse } from '../types/companyTypes';
import { InstallationsResponse } from '../types/instalationsTypes';

// Utility to get base URL based on the environment
const getBaseUrl = (): string => {
  return import.meta.env.VITE_ACCESS_BASE_URL || 'http://localhost:8001';
};

export const getAllUserInstallations = async (cognitoId: string, token: string): Promise<InstallationsResponse> => {
  const baseUrl = getBaseUrl();
  const response = await fetch(`${baseUrl}/user/${cognitoId}/installations`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  const data = await response.json();
  return data;
};

export const getAllUserCompanies = async (token: string): Promise<CompaniesResponse> => {
  const response = await fetch(
    `${import.meta.env.VITE_API_SERVICES || 'http://localhost:8001'}/api/v1/user/companies`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  const data: CompaniesResponse = await response.json();
  return data;
};

export const getCompanyServices = async (companyNumber: string, token: string): Promise<CompanyServiceResponse> => {
  const baseUrl = getBaseUrl();
  const response = await fetch(`${baseUrl}/company/${companyNumber}/installations`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  const data: CompanyServiceResponse = await response.json();
  return data;
};
